import {Box, List, ListItemText} from "@mui/material";
import * as React from "react";
import {useEffect, useRef, useState} from "react";
import Typography from "@mui/material/Typography";
import Markdown from "react-markdown";

import {Story} from "./Chat";
import IconButton from "@mui/material/IconButton";
import {ContentCopy, Done} from "@mui/icons-material";

import "./Messages.css"

interface MessagesP {
    story: Story[]
}

const noMessageText = "No messages. Write something to start a conversation";


export default function Messages({story}: MessagesP) {

    const scrollRef = useRef<HTMLUListElement>(null);

    const [successfulCopyCur, setSuccessfulCopyCur] = useState<string>("");

    useEffect(() => {
        if (story.length > 0) {
            scrollRef.current?.scrollIntoView({behavior: "smooth"});
            localStorage.setItem("story", JSON.stringify(story));
        }
    }, [story]);


    const messageBoxStyle = {
        borderRadius: "10px",
        minHeight: "30px",
        backgroundColor: "rgba(128, 128, 128, 0.2)",
    };

    const clipboardStyle = {
        width: 20,
        height: 20,
    };

    const clipboardClick = (text: string, id: string) => {
        navigator.clipboard.writeText(text).then(() => {
            setSuccessfulCopyCur(id);
            setTimeout(() => setSuccessfulCopyCur(""), 2000);
        })
    };


    const messageOn = (
        <List sx={{display: "flex", gap: "10px", flexDirection: "column"}}>
            {story.map((message: Story) =>
                <Typography sx={{
                    ...messageBoxStyle,
                    backgroundColor: message.role === "user" ? "rgba(0, 100, 300, 0.2)" : "rgba(128, 128, 128, 0.2)",
                    paddingLeft: "10px",
                    paddingRight: "10px",
                    overflow: "hidden",
                    maxWidth: "100%",
                }} key={JSON.stringify(message)}>
                    <ListItemText
                        primary={<div style={{
                            maxWidth: "100%",
                            overflowWrap: "break-word",
                            whiteSpace: "pre-wrap",
                            fontFamily: "monospace",
                        }}><Markdown components={{
                            a: ({children, href}) => (
                                <a
                                    href={href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    {children}
                                </a>
                            )
                        }}>{message.content}</Markdown></div>}
                        secondary={
                            <div style={{userSelect: "none", display: "flex", justifyContent: "space-between"}}>
                                {message.time + " | " + message.role}
                                <IconButton
                                    title={successfulCopyCur !== message.content + message.time ? "Copy text" : ""}
                                    onClick={() => clipboardClick(message.content, message.content + message.time)}
                                    sx={{...clipboardStyle}}>
                                    <div
                                        style={{
                                            transition: "opacity 0.3s ease-in-out",
                                            opacity: successfulCopyCur === message.content + message.time ? 0 : 1,
                                            position: "absolute",
                                        }}
                                    >
                                        <ContentCopy sx={{...clipboardStyle}}/>
                                    </div>
                                    <div
                                        style={{
                                            transition: "opacity 0.3s ease-in-out",
                                            opacity: successfulCopyCur === message.content + message.time ? 1 : 0,
                                            position: "absolute",
                                        }}
                                    >
                                        <Done sx={{...clipboardStyle}}/>
                                    </div>
                                </IconButton>
                            </div>
                        }
                    />
                </Typography>
            )}
            <ul ref={scrollRef}/>
        </List>
    )

    const messageOff = (
        <div style={{
            ...messageBoxStyle,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            userSelect: "none",
        }}>{noMessageText}
        </div>
    )

    return (
        <Box id="messages-box" height="78vh" width="100%" overflow="auto" py={5}>
            {story.length > 0 ? messageOn : messageOff}
        </Box>
    );
}
